'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStyles = undefined;

var _templateObject = _taggedTemplateLiteral([''], ['']);

exports.ModalComponent = ModalComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

if (!process.env.REACT_APP_SERVER) {
  _reactModal2.default.setAppElement('#root');
}

var defaultStyles = exports.defaultStyles = (0, _bduiStyles.css)(_templateObject);

function ModalComponent(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ['className']);

  return _react2.default.createElement(_reactModal2.default, Object.assign({}, props, { className: className }));
}

ModalComponent.propTypes = {
  className: _propTypes2.default.string
};

ModalComponent.defaultProps = {
  className: ''
};

exports.default = (0, _bduiStyles2.default)(defaultStyles)(ModalComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-modal/build/Modal.js
// module id = 1276
// module chunks = 0